import PaginationButton from "./PaginationButton";
import paginationPreviousSvg from "../assets/pagination-prev.svg";
import paginationNextSvg from "../assets/pagination-next.svg";
import React from "react";

interface Props {
  page: number;
  loading?: boolean;
  onPrevPage: () => Promise<void>;
  onNextPage: () => Promise<void>;
  hasNextPage?: boolean;
  hasPrevPage?: boolean;
}

const Pagination = ({
  page,
  loading,
  onPrevPage,
  onNextPage,
  hasNextPage,
  hasPrevPage,
}: Props) => (
  <div className="gpc__orders__pagination">
    <div className="gpc__pagination-control">
      {(page !== 1 || hasPrevPage) && (
        <PaginationButton onClick={onPrevPage} disabled={loading}>
          <img src={paginationPreviousSvg} alt="gpc__pagination previous" />
        </PaginationButton>
      )}
      <div>{page}</div>
      {hasNextPage && (
        <PaginationButton onClick={onNextPage} disabled={loading}>
          <img src={paginationNextSvg} alt="gpc__pagination next" />
        </PaginationButton>
      )}
    </div>
  </div>
);

export default Pagination;
